module.exports = __webpack_public_path__ + "files/b2e61b88dc90ace92964aa3a50ef2758.png";